<table
  class="details-table"
  *ngIf="transcribeJob$ | async as transcribeJob">
  <tr *ngIf="bookedAtInfo">
    <td class="detail-label">
      {{ "bookedAt" | i18n }}
    </td>
    <td>{{ bookedAtInfo }}</td>
  </tr>
  <tr *ngIf="cancelledAtInfo">
    <td class="detail-label">
      {{ "canceledAt" | i18n }}
    </td>
    <td>{{ cancelledAtInfo }}</td>
  </tr>
  <tr *ngIf="transcribeJob.jobType">
    <td class="detail-label">
      {{ "jobType" | i18n }}
    </td>
    <td>
      {{ "jobTypeEnum." + transcribeJob.jobType | i18n }}
    </td>
  </tr>
  <tr *ngIf="transcribeJob.invitee">
    <td class="detail-label">
      {{ "employee" | i18n }}
    </td>
    <td>
      {{ transcribeJob.invitee.personalData.firstName }}
      {{ transcribeJob.invitee.personalData.lastName }}<br />
    </td>
  </tr>
  <tr *ngIf="transcribeJob.invitee?.personalData?.poolerType">
    <td class="detail-label">
      {{ "poolerType" | i18n }}
    </td>
    <td>
      {{ transcribeJob.invitee.personalData.poolerType?.displayName }}
    </td>
  </tr>
</table>
